export const RegionTypes = {
  NSW1: "NSW1",
  QLD1: "QLD1",
  VIC1: "VIC1",
  SA1: "SA1",
  TAS1: "TAS1"
};
